import { render, staticRenderFns } from "./test-component.vue?vue&type=template&id=3d369b66&"
import script from "./test-component.vue?vue&type=script&lang=js&"
export * from "./test-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports